import React, { useEffect, useState } from "react";
import axios from "axios";
import Navbar from "../components/Navbar";
import Footer1 from "../components/Footer1";
import "./Wishlist.css";
import { useNavigate } from "react-router-dom";

const Wishlist = () => {
  const [paintings, setPaintings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hoveredPainting, setHoveredPainting] = useState(null);
  const [hoveredHeart, setHoveredHeart] = useState(null);
  const [removing, setRemoving] = useState(null); // id being removed
  const navigate = useNavigate();

  // read token from localStorage (change if you store token elsewhere)
  const token = localStorage.getItem("authToken") || "";

  useEffect(() => {

    const fetchWishlist = async () => {
      setLoading(true);
      try {
        const res = await axios.get("http://localhost:8080/api/wishlist/my", {
          headers: {
            Authorization: token ? `Bearer ${token}` : "",
          },
        });
        // Expecting res.data = array of Painting (same shape as /api/paintings/all)
        setPaintings(res.data || []);
      } catch (err) {
        console.error("Error loading wishlist:", err);
        // if unauthorized, you might want to redirect to login or show a message
      } finally {
        setLoading(false);
      }
    };

    fetchWishlist();
  }, [token]);

  const removeFromWishlist = async (id) => {
  if (removing) return; // prevent multiple clicks
  setRemoving(id);

  try {
    await axios.delete(`http://localhost:8080/api/wishlist/remove/${id}`, {
      headers: { Authorization: token ? `Bearer ${token}` : "" },
    });

    // remove from local state
    setPaintings((prev) => prev.filter((p) => p.id !== id));
  } catch (err) {
    console.error("Remove from wishlist failed:", err);
    alert("Could not remove item from wishlist. Try again.");
  } finally {
    setRemoving(null);
  }
};

  const handleCardClick = (id) => {
    navigate(`/paintingDetails/${id}`);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      {/* <Navbar /> */}
      <div className="top_banner small_top">
        <div className="top_banner_inner">
          <h1>Your Wishlist</h1>
          <p>Saved artworks you loved</p>
        </div>
      </div>

      <div className="wishlist_container">
        <h4><span>My</span> Wishlist</h4>

        {loading ? (
          <div className="loader-container">
            <div className="spinner"></div>
            <p>Loading your picks...</p>
          </div>
        ) : paintings.length === 0 ? (
          <div className="empty_state">
            <p>Your wishlist is empty.</p>
            <button className="btn-cta" onClick={() => navigate("/allPaintings")}>
              Explore Paintings
            </button>
          </div>
        ) : (
          <div className="wishlist_grid">
            {paintings.map((painting) => (
              <div
                key={painting.id}
                className="painting_card"
                onClick={() => handleCardClick(painting.id)}
                onMouseEnter={() => setHoveredPainting(painting.id)}
                onMouseLeave={() => setHoveredPainting(null)}
              >
                {painting.images && painting.images.length > 0 ? (
                  <div
                    className="painting_image"
                    style={{
                      backgroundImage: `url(${
                        hoveredPainting === painting.id && painting.images[1]
                          ? `${painting.images[1].imageUrl}`
                          : `${painting.images[0].imageUrl}`
                      })`,
                    }}
                  >
                    <div
                      className="add_to_wishList_div"
                      onMouseEnter={(e) => {
                        e.stopPropagation();
                        setHoveredHeart(painting.id);
                      }}
                      onMouseLeave={(e) => {
                        e.stopPropagation();
                        setHoveredHeart(null);
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (removing) return;
                        removeFromWishlist(painting.id);
                      }}
                      title="Remove from wishlist"
                    >
                      {removing === painting.id ? (
                        <div className="small-spinner" />
                      ) : hoveredHeart != painting.id ? (
                        <i className="fa-solid fa-heart heart_icon filled" />
                      ) : (
                        <i className="fa-regular fa-heart heart_icon" />
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="no_image">No Image</div>
                )}

                <div className="painting_info">
                  <div className="painting-info-content">
                    <h3 className="painting_title">{painting?.title}</h3>
                    <p className="painting_size">{painting?.size || "Size not specified"}</p>
                  </div>

                  <div className="arrow-piainting-info">
                    <i className="fa-solid fa-arrow-right" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <Footer1 />
    </>
  );
};

export default Wishlist;